import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv, SummaryDiv } from '../TextStyle'
import { imgItems, imgLinks } from './ImageItems'
import { LinkText } from '@/components/elements/LinkText'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Index } from '@/components/enlayouts/Legal/Index'
import { SectionTitle } from '@/components/enlayouts/Legal/SectionTitle'

const sectionTitle = {
  children: <h2>Image Policy</h2>,
}

const tSummary = (
  <p>
    This Image Policy (hereinafter referred to as the &quot;Policy&quot;) outlines the terms for the use of images made available by the TRIAL Group (including TRIAL Holdings, Inc. and its group companies*), herein referred to as the &quot;Images,&quot; in materials intended for the media.
    <br />
    By downloading the Images, the person who downloads them (hereinafter referred to as the &quot;User&quot;) is considered to have agreed to this Policy.
    <br />
    *Click 
    <LinkText path="/en/company/overview/" text=" here " />
    for a list of group companies of TRIAL Holdings, Inc.
  </p>
)
export const ImagePolicyPage = () => {
  return (
    <>
      <Head
        title="Image Policy"
        description="The code of conduct for TRIAL Holdings, Inc."
        ogp={{ type: 'article', url: 'en/legal/image-terms/' }}
      />
      <ImageContainer>
        <SectionTitle {...sectionTitle} />
        <Spacer h={{ pc: 70, sp: 60 }} />
        <SummaryDiv>{tSummary}</SummaryDiv>
        <Spacer h={{ pc: 70, sp: 35 }} />
        <Index columnGap={46} listType="article" links={imgLinks} />
        <Spacer h={{ pc: 70, sp: 40 }} />
        {imgItems.map(({ children, id }, index) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < imgItems.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </ImageContainer>
    </>
  )
}
ImagePolicyPage.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'Legal',
    subTitle: '',
  }

  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Legal', path: '/en/legal/' },
    { name: 'Image Policy', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const ImageContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 68px;
  }
`
